import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { ProjectMenu } from '@app/services/project.service';

@Component({
    selector: 'tt-project-menu-view',
    templateUrl: './project-menu-view.component.html',
    styleUrls: ['./project-menu-view.component.css'],
})
export class ProjectMenuViewComponent {
    public params: { project_keyno: string };

    public webpageHeading: string = '';

    constructor(private state: StateService) {
        this.params = state.getStateParams() as { project_keyno: string };
    }

    public setHeading(projectMenuGet: ProjectMenu) {
        this.webpageHeading = projectMenuGet.webpage_heading;
        this.state.setTitleOverride(projectMenuGet.webpage_heading, false);
    }
}
